<ng-container *ngIf="showAnyLabel()">
  <div class="label-block">
    <ng-container *ngFor="let label of labels">
      <xvi-label
        *ngIf="label.show"
        [title]="label.message"
        [itemClass]="label.class"
        [widgetData]="label.widgetData || {}"
      ></xvi-label>
    </ng-container>
  </div>
</ng-container>
